import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import useAxiosPrivate from "./hooks/useAxiosPrivate"
import Loading from "./Loading"
import UpArrow from "./icon/UpArrow"
import DownArrow from "./icon/DownArrow"
import { downloadExcel } from "react-export-table-to-excel";
import ExportSVG from './icon/ExportSVG'
import HelpModal from './util/HelpModal'
import InvestorSectorChart from "./InvestorSectorChart"
import InvestmentHistory from "./InvestmentHistory"
import InvestmentActivity, {getClassName} from "./InvestmentActivity"


export const numberFormat = (value, condition) => {
    if (!value) {
        return "-"
    }
    if (condition) {
        return (Math.round(value/1000)).toLocaleString('en-IN')
    }
    if (value) {
        return value.toLocaleString('en-IN', { minimumFractionDigits: 2 })
    }
}


function Investor() {
    window.scrollTo(0, 0)
    const { investor } = useParams();
    
    
    const [pageData, setpageData] = useState({});
    const [sortingData, setSortingData] = useState({});
    const [nav, setNav] = useState("current");
    const [show, setShow] = useState(false);
    const [stock, setStock] = useState();
    const [investorSymbol, setInvestorSymbol] = useState('');
    const axiosPrivate = useAxiosPrivate();

    if (investor != investorSymbol) {
        setInvestorSymbol(investor)
    }

    const viewHelper = (symbol) => {
        setStock(symbol)
        setShow(true)
    }

    const getUrl = (url) => {
        return "/CompanyInvestor/" + url
    }

    const companyDetails = async () => {
        setpageData({})
        let url = ""
        localStorage.removeItem("SortData")
        localStorage.removeItem("SortDataItem")
        url = process.env.REACT_APP_BASE_URL + "/v1/current-holdings/" + investor + "?access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;
        const cdresponse = await axiosPrivate.get(url);
        //  document.title = cdresponse.data.stock_name + "- 3M Score | Stock Scoring Model | Moat, Management & MOS score | Compare Stocks on key financial attributes | Investing checklist. ";
        if (cdresponse.data.status === "Not Found") {
            setpageData({ dataNotFound: true })
            return
        }
        document.title = cdresponse.data.shareholder_name + " : Superinvestors Portfolio  ";
        setSortingData(cdresponse.data); ////////
        const itemsData = JSON.parse(JSON.stringify(cdresponse.data))
        let tempData = itemsData["holdings"]
        tempData.sort(dynamicSortDescending('investment_value'));
        let finalData = itemsData
        finalData["holdings"] = tempData
        setpageData(finalData)

    }

    function handleDownloadExcel() {

        let header = ["S. No.", "Stock Symbol", "Name", "% of Portfolio", "Activity", "Change", "Change%", "Shares", "Current Price", "Investment Value (Cr)", "52W Low", "52W High", "% Above 52W low", "Industry", "Sector"]
        let body = []

        pageData?.investments.forEach((item, index) => {
            let tempData = [index + 1]
            tempData.push(item.stock_symbol)
            tempData.push(item.name)
            tempData.push(item.pctOfProfile)
            tempData.push(item.activity)
            tempData.push(item.change)
            tempData.push(item.pctChange)
            tempData.push(item.share)
            tempData.push(item.currentPrice)
            tempData.push(item.investmentValue)
            tempData.push(item.low52)
            tempData.push(item.high52)
            tempData.push(item.pctAbove52WLow)
            tempData.push(item.industry)
            tempData.push(item.sector)
            body.push(tempData)
        })


        downloadExcel({
            fileName: "Investor",
            sheet: "Investor",
            tablePayload: {
                header,
                // accept two different data structures
                body: body,
            },
        });
    }

    const getSectorURL = (url) => {
        return "/Sector/" + url
    }

    const getIndustryURL = (url) => {
        return "/Industry/" + url
    }

    const SortIndicator = (indicator) => {
        const sortData = JSON.parse(localStorage.getItem('SortData'))
        const SortDataItem = localStorage.getItem('SortDataItem')
        if (indicator === SortDataItem) {
            if (sortData["pointer"]) {
                return [true, true]
            } else {
                return [true, false]
            }
        }
        return [false, false]
    }

    const showSorted = (pointer) => {
        const sortData = JSON.parse(localStorage.getItem('SortData'))
        if (sortData !== null) {
            if (Object.keys(sortData).includes('pointer')) {
                if (sortData["pointer"]) {
                    localStorage.setItem("SortData", JSON.stringify({ pointer: false }));
                    localStorage.setItem("SortDataItem", pointer);
                } else {
                    localStorage.setItem("SortData", JSON.stringify({ pointer: true }));
                    localStorage.setItem("SortDataItem", pointer);
                }
            } else {
                localStorage.setItem("SortData", JSON.stringify({ pointer: true }));
                localStorage.setItem("SortDataItem", pointer);
            }
        } else {
            localStorage.setItem("SortData", JSON.stringify({ pointer: true }));
            localStorage.setItem("SortDataItem", pointer);
        }
        const finalSortData = JSON.parse(localStorage.getItem('SortData'))

        const itemsData = JSON.parse(JSON.stringify(sortingData))
        let tempData = itemsData["holdings"]
        if (finalSortData["pointer"]) {
            if (['sector', 'industry', 'activity'].includes(pointer)) {
                tempData.sort(dynamicSortAscendingString(pointer));
            } else {
                tempData.sort(dynamicSortAscending(pointer));
            }
        } else {
            if (['sector', 'industry', 'activity'].includes(pointer)) {
                tempData.sort(dynamicSortDescendingString(pointer));
            } else {
                tempData.sort(dynamicSortDescending(pointer));
            }
        }
        let finalData = itemsData
        finalData["holdings"] = tempData
        setpageData(finalData)
    }

    function forceDefault(data) {
        if (data === "-") {
            return 0
        } else {
            return data
        }
    }

    function dynamicSortDescending(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            console.log(a[property])
            console.log(b[property])
            var result = (parseFloat(forceDefault(a[property])) > parseFloat(forceDefault(b[property]))) ? -1 : (parseFloat(forceDefault(a[property])) < parseFloat(forceDefault(b[property]))) ? 1 : 0;
            return result * sortOrder;
        }
    }


    function dynamicSortAscending(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (parseFloat(forceDefault(a[property])) < parseFloat(forceDefault(b[property]))) ? -1 : (parseFloat(forceDefault(a[property])) > parseFloat(forceDefault(b[property]))) ? 1 : 0;
            return result * sortOrder;
        }
    }


    function dynamicSortDescendingString(property) {
        console.log("inside sort")
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (String(a[property]) > String(b[property])) ? -1 : (String(a[property]) < String(b[property])) ? 1 : 0;
            return result * sortOrder;
        }
    }


    function dynamicSortAscendingString(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (String(a[property]) < String(b[property])) ? -1 : (String(a[property]) > String(b[property])) ? 1 : 0;
            return result * sortOrder;
        }
    } 

    useEffect(() => {
        companyDetails()
    }, [investorSymbol])


    return (
        <div className="Investor" style={{ minHeight: "700px",fontSize:"10px", padding: "110px"}}>

            

            {nav === "current" &&
                <section className="Peers">
                    {Object.keys(pageData).length !== 0 &&
                        <>
                            <section className="optionsFinData">
                                <div className="leftAlign growthCompanyName" style={{ paddingLeft: "0px", fontWeight: "600" }}>
                            {pageData.shareholder_name}
                                </div>
                                <div className="rightAlign">
                                    <div className="optionButtonPrimary" onClick={handleDownloadExcel} style={{ cursor: "pointer" }}>
                                {// <ExportSVG />
                                }
                                    </div>
                                </div>
                    </section>

                    <div className="CompanyNav" style={{ padding: "10px 0px" }}>

                        <div className="CompanyMenu" id="current" onClick={() => {
                            setNav('current')
                        }
                        } style={nav === "current" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Current</div>
                        <div className="CompanyMenu" id="Activity" onClick={() => {
                            setNav('Activity')
                        }
                        } style={nav === "Activity" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Activity</div>
                        <div className="CompanyMenu" id="History" onClick={() => {
                            setNav('History')
                        }
                        } style={nav === "History" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>History</div>

                    </div>
                    
                            <div style={{ overflow: "auto", backgroundColor: "white", borderRadius: "10px" }}>
                                <table className="PeersTable finData" style={{ width: "100%" }}>
                                    <thead style={{ backgroundColor: "white", zIndex: "20" }}>
                                        <tr>
                                            <th className="PeerColumnHeading" style={{ whiteSpace: "nowrap" }}><div>Symbol</div></th>
                                            <th className="PeerColumnHeading" style={{ whiteSpace: "nowrap" }}><div>Stock</div></th>
                                    <th className="PeerColumnHeading PeerTabledataCenter"><div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px", width: "100%" }} onClick={() => showSorted('pct_of_profile')}><div>% of Portfolio</div><div style={{ paddingTop: "5px" }}>{SortIndicator("pct_of_profile")[0] ? <div>{SortIndicator("pct_of_profile")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}</div></div></th>
                                    <th className="PeerColumnHeading PeerTabledataCenter"><div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px", width: "100%" }} onClick={() => showSorted('pct_change')}><div>% Change</div><div style={{ paddingTop: "5px" }}>{SortIndicator("pct_change")[0] ? <div>{SortIndicator("pct_change")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}</div></div></th>
                                    <th className="PeerColumnHeading PeerTabledataCenter"><div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px", width: "100%" }} onClick={() => showSorted('number_of_shares')}><div>Shares (k)</div><div style={{ paddingTop: "5px" }}>{SortIndicator("number_of_shares")[0] ? <div>{SortIndicator("number_of_shares")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}</div></div></th>
                                    <th className="PeerColumnHeading PeerTabledataCenter"><div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px", width: "100%" }} onClick={() => showSorted('investment_value')}><div>Value (Cr)</div><div style={{ paddingTop: "5px" }}>{SortIndicator("investment_value")[0] ? <div>{SortIndicator("investment_value")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}</div></div></th>
                                    <th className="PeerColumnHeading PeerTabledataCenter"><div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px", width: "100%" }} onClick={() => showSorted('current_price')}><div>Price</div><div style={{ paddingTop: "5px" }}>{SortIndicator("current_price")[0] ? <div>{SortIndicator("current_price")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}</div></div></th>
                                    
                                    <th className="PeerColumnHeading PeerTabledataCenter"><div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px", width: "100%" }} onClick={() => showSorted('pct_above_low_52')}><div>% Above 52w low</div><div style={{ paddingTop: "5px" }}>{SortIndicator("pct_above_low_52")[0] ? <div>{SortIndicator("pct_above_low_52")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}</div></div></th>
                                    <th className="PeerColumnHeading PeerTabledataCenter"><div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px", width: "100%" }} onClick={() => showSorted('pct_below_high52')}><div>% Below 52w high</div><div style={{ paddingTop: "5px" }}>{SortIndicator("pct_below_high52")[0] ? <div>{SortIndicator("pct_below_high52")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}</div></div></th>
                                    <th className="PeerColumnHeading PeerTabledataCenter"><div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px", width: "100%" }} onClick={() => showSorted('low_52')}><div>52w low</div><div style={{ paddingTop: "5px" }}>{SortIndicator("low_52")[0] ? <div>{SortIndicator("low_52")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}</div></div></th>
                                    <th className="PeerColumnHeading PeerTabledataCenter"><div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px", width: "100%" }} onClick={() => showSorted('high_52')}><div>52w high</div><div style={{ paddingTop: "5px" }}>{SortIndicator("high_52")[0] ? <div>{SortIndicator("high_52")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}</div></div></th>
                                    <th className="PeerColumnHeading PeerTabledataCenter"><div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px", width: "100%" }} onClick={() => showSorted('industry')}><div>Industry</div><div style={{ paddingTop: "5px" }}>{SortIndicator("industry")[0] ? <div>{SortIndicator("industry")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}</div></div></th>
                                    <th className="PeerColumnHeading PeerTabledataCenter"><div style={{ cursor: "pointer", color: "blue", display: "flex", justifyContent: "center", paddingTop: "5px", width: "100%" }} onClick={() => showSorted('sector')}><div>Sector</div><div style={{ paddingTop: "5px" }}>{SortIndicator("sector")[0] ? <div>{SortIndicator("sector")[1] ? <DownArrow /> : < UpArrow />}</div> : <div style={{ minHeight: "25px" }}>&nbsp;</div>}</div></div></th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                {pageData.holdings.map((dataKey, index) => (
                                    <tr>
                                        <td className={index % 2 === 0 ? "PeerTabledataLeft SubHeader OddDiv" : "PeerTabledataLeft SubHeader"}><div className="StockLink"><a href={getUrl(dataKey.stock_symbol)} target="_blank" style={{ textDecoration: "None" }}>{dataKey.stock_symbol}</a></div></td>
                                        <td className={index % 2 === 0 ? "PeerTabledataLeft SubHeader OddDiv" : "PeerTabledataLeft SubHeader"} style={{ whiteSpace: "nowrap" }}>{dataKey.company_name}</td>
                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ minWidth: "80px" }}>{dataKey.pct_of_profile}</td>
                                        <td className={getClassName(index, dataKey.pct_change)} style={{ minWidth: "80px" }}>{dataKey.pct_change} %</td>
                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ minWidth: "80px" }}>{numberFormat(dataKey.number_of_shares, true)}</td>
                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ minWidth: "80px" }}>{numberFormat(dataKey.investment_value, false)}</td>
                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ minWidth: "80px" }}>{numberFormat(dataKey.current_price, false)}</td>
                      
                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ minWidth: "80px" }}>{numberFormat(dataKey.pct_above_low_52, false)}</td>
                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ minWidth: "80px" }}>{numberFormat(dataKey.pct_below_high52, false)}</td>
                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ minWidth: "80px" }}>{numberFormat(dataKey.low_52, false)}</td>
                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ minWidth: "80px" }}>{numberFormat(dataKey.high_52, false)}</td>
                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap" }}>{dataKey.industry}</td>
                                        <td className={index % 2 === 0 ? "PeerTabledataCenter SubHeader OddDiv" : "PeerTabledataCenter SubHeader"} style={{ maxWidth: "100%", whiteSpace: "nowrap" }}>{dataKey.sector}</td>
                                            </tr>
                                ))}
                                {(pageData.dataNotFound === true || pageData.holdings?.length === 0 || pageData.holdings === undefined) &&
                                    <tr>
                                        <td>Data not found</td>
                                    </tr>
                                }
                                    </tbody>
                                </table>
                            </div>

                            <div>
                        {pageData.sector_analysis != undefined && Object.keys(pageData?.sector_analysis).length > 0 &&
                                    <InvestorSectorChart investor={investor} sectorData={pageData.sector_analysis} source="investor"/>
                                }
                            </div>
                        </>
                    }{
                        Object.keys(pageData).length === 0 &&
                        <Loading />
                    }
                </section>
            }
            {nav === "History" &&
                <>

                <InvestmentHistory investor={investorSymbol} nav={nav} setNav={setNav} />
                </>
            }
            {nav === "Activity" &&
                <>
                
                <InvestmentActivity investor={investorSymbol} nav={nav} setNav={setNav}/>
                </>
            }
        </div>
    );
}
export default Investor;